import React, { useEffect, useContext } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  Outlet,
} from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Registrations from "./pages/cdp/Registrations";
import Demographics from "./pages/cdp/Demographics";
import Header from "./components/Features/Header";
import ChatTag from "./components/Features/ChatTag";
import Horoscope from "./components/Products/Astrology/Horoscope";
import Campaigns from "./components/Services/Notification/Campaigns";
import Listing from "./components/AiHub/Webstories/Listing";
import Login from "./pages/Login";
import Anonymous from "./pages/cdp/Anonymous";
import Categories from "./pages/cdp/Categories";
import Registered from "./pages/cdp/Registered";
import Authors from "./pages/cdp/Authors";
import ArticleListing from "./components/AiHub/AiArticle/ArticleListing";
import AddArticle from "./components/AiHub/AiArticle/AddArticle";
import ArticleGenerator from "./components/AiHub/AiArticle/ArticleGenerator";
import Translation from "./pages/Translation";
import Support from "./pages/Support";
import { AuthProvider, AuthContext } from "./hoc/AuthContext";
import SubscriptionAnalytics from "./pages/cdp/SubscriptionAnalytics";
import CampaignsList from "./pages/notification/campaigns";
import Notifications from "./pages/notification/notification";
import NotificationsSettings from "./pages/notification/setting";
import NotificationsDashboard from "./pages/notification/dashboard";
import Podcast from "./pages/Podcast";
import EpaperEditions from "./pages/Epaper/EpaperEditions";
import LoyaltyProgram from "./pages/Loyalty/LoyaltyProgram";
import AddLoyaltyProgram from "./pages/Loyalty/AddLoyaltyProgram";

import RequireAccess from "./RequireAccess";
import Unauthorized from "./pages/Unauthorized";
import Prebiddashboard from "./pages/prebidAds/Prebiddashboard";
import Transactions from "./pages/cdp/Transactions";
import SubscriptionMetrics from "./pages/cdp/SubscriptionMetrics";
import CustomersListing from "./pages/cdp/customers/CustomersListing";
import CustomerProfile from "./pages/cdp/customers/CustomerProfile";
import LoyaltyOffers from "./pages/Loyalty/LoyaltyOffers";
import BrandOffers from "./pages/Loyalty/BrandOffers";
import OfferCoupons from "./pages/Loyalty/OfferCoupons";
import AddBrandForm from "./pages/Loyalty/AddBrandForm";
import AddOfferForm from "./pages/Loyalty/AddOfferForm";
import AddCouponForm from "./pages/Loyalty/AddCouponForm";
import JagranNextCampaigns from "./pages/JagranNext/CampaignList";
import JagranNextCampaignForm from "./pages/JagranNext/CampaignForm";
import JagranNextCampaignDetail from "./pages/JagranNext/CampaignDetail";
import JagranNextSeasonDetail from "./pages/JagranNext/SeasonDetail";
import JagranNextLeads from "./pages/JagranNext/Leads";

const PrivateRouteLayout = () => {
  const { isAuthenticated, authLoading } = useContext(AuthContext);

  if (authLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white">
        <div
          className="h-10 w-10 animate-spin rounded-full border-4 border-gray-200 border-t-cyan-500"
          aria-label="Loading"
        />
      </div>
    );
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

function App() {
  useEffect(() => {
    document.documentElement.classList.add("h-full", "bg-white");
    document.body.classList.add("h-full");

    return () => {
      document.documentElement.classList.remove("h-full", "bg-white");
      document.body.classList.remove("h-full");
    };
  }, []);

  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route element={<PrivateRouteLayout />}>
            <Route path="/" element={<Dashboard />} />
            <Route
              path="/cdp/registrations"
              element={
                <RequireAccess requiredRoute="cdp/registrations">
                  <Registrations />
                </RequireAccess>
              }
            />
            <Route
              path="/cdp/registrations/demographics"
              element={
                <RequireAccess requiredRoute="cdp/registrations">
                  <Demographics />
                </RequireAccess>
              }
            />
            <Route
              path="/cdp/subscription/transactions"
              element={
                <RequireAccess requiredRoute="cdp/registrations">
                  <Transactions />
                </RequireAccess>
              }
            />
            <Route
              path="/cdp/subscription/metrics"
              element={
                <RequireAccess requiredRoute="cdp/registrations">
                  <SubscriptionMetrics />
                </RequireAccess>
              }
            />
            <Route
              path="/cdp/customers"
              element={
                <RequireAccess requiredRoute="cdp/registrations">
                  <CustomersListing />
                </RequireAccess>
              }
            />
            <Route
              path="/cdp/customers/:id"
              element={
                <RequireAccess requiredRoute="cdp/registrations">
                  <CustomerProfile />
                </RequireAccess>
              }
            />
            <Route
              path="/cdp/subscription-analytics"
              element={
                <RequireAccess requiredRoute="cdp/registrations">
                  <SubscriptionAnalytics />
                </RequireAccess>
              }
            />
            <Route path="/features/header" element={<Header />} />
            <Route path="/features/chat-tag" element={<ChatTag />} />
            <Route path="/services/prebidAds/dashboard" element={<Prebiddashboard />} />
            <Route path="/products/astrology/horoscope" element={<Horoscope />} />
            <Route path="/products/jagran-next" element={<JagranNextCampaigns />} />
            <Route path="/products/jagran-next/leads" element={<JagranNextLeads />} />
            <Route path="/products/jagran-next/campaigns/new" element={<JagranNextCampaignForm />} />
            <Route path="/products/jagran-next/campaigns/:campaignId/edit" element={<JagranNextCampaignForm />} />
            <Route path="/products/jagran-next/campaigns/:campaignId" element={<JagranNextCampaignDetail />} />
            <Route
              path="/products/jagran-next/campaigns/:campaignId/seasons/:seasonId"
              element={<JagranNextSeasonDetail />}
            />
            <Route
              path="/cdp/support/tickets"
              element={
                <RequireAccess requiredRoute="cdp/registrations">
                  <Support />
                </RequireAccess>
              }
            />
            <Route path="/services/notification/campaign" element={<Campaigns />} />
            <Route
              path="/services/notification/list"
              element={
                <RequireAccess requiredRoute="services/notification/campaigns">
                  <Notifications />
                </RequireAccess>
              }
            />
            <Route
              path="/services/notification/setting"
              element={
                <RequireAccess requiredRoute="services/notification/setting">
                  <NotificationsSettings />
                </RequireAccess>
              }
            />
            <Route
              path="/services/notification/topics"
              element={
                <RequireAccess requiredRoute="services/notification/campaigns">
                  <CampaignsList />
                </RequireAccess>
              }
            />
            <Route path="/services/notification/dashboard" element={<NotificationsDashboard />} />
            <Route path="/ai-hub/webstories/listing" element={<Listing />} />
            <Route path="/services/podcast/listing" element={<Podcast />} />
            <Route path="/services/epaper/editions" element={<EpaperEditions />} />
            <Route path="/services/loyalty-program" element={<LoyaltyProgram />} />
            <Route path="/services/loyalty-program/add" element={<AddLoyaltyProgram />} />
            <Route path="/services/loyalty-program/edit/:id" element={<AddLoyaltyProgram />} />
            <Route path="/services/loyalty-offers" element={<LoyaltyOffers />} />
            <Route path="/services/loyalty-offers/add" element={<AddBrandForm />} />
            <Route path="/services/loyalty-offers/edit/:id" element={<AddBrandForm />} />
            <Route path="/services/loyalty-offers/:brandId/offers" element={<BrandOffers />} />
            <Route path="/services/loyalty-offers/:brandId/offers/add" element={<AddOfferForm />} />
            <Route path="/services/loyalty-offers/:brandId/offers/edit/:offerId" element={<AddOfferForm />} />
            <Route
              path="/services/loyalty-offers/:brandId/offers/:offerId/coupons"
              element={<OfferCoupons />}
            />
            <Route
              path="/services/loyalty-offers/:brandId/offers/:offerId/coupons/add"
              element={<AddCouponForm />}
            />
            <Route
              path="/services/loyalty-offers/:brandId/offers/:offerId/coupons/edit/:couponId"
              element={<AddCouponForm />}
            />
            <Route path="/ai-article/ai-article" element={<ArticleListing />} />
            <Route path="/ai-article/add-article" element={<AddArticle />} />
            <Route path="/ai-article/article-generator" element={<ArticleGenerator />} />
            <Route path="/ai-hub/translation" element={<Translation />} />
            <Route
              path="/cdp/anonymous"
              element={
                <RequireAccess requiredRoute="cdp/registrations">
                  <Anonymous />
                </RequireAccess>
              }
            />
            <Route
              path="/cdp/anonymous/registered"
              element={
                <RequireAccess requiredRoute="cdp/registrations">
                  <Registered />
                </RequireAccess>
              }
            />
            <Route
              path="/cdp/anonymous/categories"
              element={
                <RequireAccess requiredRoute="cdp/registrations">
                  <Categories />
                </RequireAccess>
              }
            />
            <Route
              path="/cdp/anonymous/articles"
              element={
                <RequireAccess requiredRoute="cdp/registrations">
                  <Authors />
                </RequireAccess>
              }
            />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
